export const name = 'loginButton' as const
